import { createHttpClient } from './http.js';

export function createServiceJourneyApi({ baseUrl, siteKey } = {}) {
    const http = createHttpClient({ baseUrl, siteKey });

    return {
        check: ({ postcode } = {}) => http.post('/service_journey_check', {
            body: { postcode }
        }),
        searchAddress: ({ query } = {}) => http.get('/ashp_address_search', {
            params: { q: query }
        }),
        submit: payload => http.post('/service_journey_submit', {
            body: payload,
            action: 'service_journey_submit'
        }),
        getPartnerBranding: ({ partnerId } = {}) => http.get('/partner_branding', {
            params: { partner: partnerId }
        })
    };
}
